import pickBy from 'lodash/pickBy';
import { isObject } from './type';
import { arrify } from './arrayUtils';
import { identity } from './fp';

/**
 * Build an object based on the non-object seed value.
 * @param {*} val seed value
 * @param {Object} parsers
 * @param {function(*):string} parsers.parseKey Build a key from the seed or
 * a part of it
 * @param {function(*):*} parsers.parseValue Build a value from the seed or
 * a part of it
 * @returns {Object} new object
 */
function objectify(val, {
  parseKey = identity,
  parseValue = identity,
} = {}) {
  let objectified;
  if (isObject(val)) {
    objectified = val;
  } else {
    objectified = arrify(val).reduce(
      (obj, currentSeed) => {
        // eslint-disable-next-line no-param-reassign
        obj[parseKey(currentSeed)] = parseValue(currentSeed);
        return obj;
      },
      {},
    );
  }
  return objectified;
}

/**
 * Creates an object composed of the object properties that begin with keyPrefix
 * @param {Object} object - The source object
 * @param {string} keyPrefix - The prefix of the targeted keys
 * @return {Object} The new object
 */
const pickByKeyPrefix = (object, keyPrefix) => pickBy(
  object, (_, key) => key.indexOf(keyPrefix) === 0,
);

export {
  objectify,
  pickBy,
  pickByKeyPrefix,
};
